/* eslint-disable no-undef */
import React, { Component, useState, useEffect } from "react";
import { Trans, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from "axios";
import subscribe from "../../auth/subscribe";
import FloatingAlert from "../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../helpers/bgSliders";
import { setAgencyData, logtracker, saveTracker } from "../../helpers/agencyTracker";
import "./NewAsiacellSubscribePage.scss";
import * as localLang from "../../i18n/i18n";
import NewAsiacellSubscribePageDisplay from "./NewAsiacellSubscribePage.styled";

import { getPhoneByHeader } from "./services"
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";
import { useHistory } from 'react-router-dom';

function NewAsiacellSubscribePage({ t }) {
  const history = useHistory();

  const [enriched, setenriched] = useState(false);
  // const [activeData, setActiveData] = useState('');
  // const [headers, setHeaders] = useState('');
  const [clickId, setClickId] = useState('');
  const [Mcpuniqid, setMcpuniqid] = useState('');



  const [headerData, setHeaderData] = useState({});


  const [showverify, setShowverify] = useState(false);
  const [showsubscribeSucess, setShowsubscribeSucess] = useState(false);

  const [showLoading, setshowLoading] = useState(false);
  const [errorMesg, setErrorMesg] = useState(false);
  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [visibleModal, setvisibleModal] = useState(false);


  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };






  useEffect(() => {
    const lang = localStorage.getItem('i18nextLng');
    if (lang !== 'ar' || !lang) {
      localStorage.setItem("i18nextLng", 'ar');
      localLang.setlangSubscribe();
    }
    const urlsearch = window.location.search;

    if (urlsearch !== "") {
      setAgencyData(urlsearch);
    }
    fetchit();


  }, [])





  async function fetchit() {
    var linkheader = "http://aciq.playit.mobi/checkheaderasiacell.php";
    const headerData = await getPhoneByHeader(linkheader);
    console.log('headerData', headerData);
    /* const headerData = {
      Msisdn: 9647748475064,
      Headers: 'eyJNc2lzZG4iOiI5NjQ3NzQ4NDc1MDY0IiwiQWNjZXB0LUVuY29kaW5nIjoiZ3ppcCwgZGVmbGF0ZSIsIlJlZmVyZXIiOiJodHRwOi8vYWNpcS5wbGF5aXQubW9iaS9zaWdudXAvP3BhcmFtZXRlcj13cHNzdnQ2YmlvaGsxNWY5M2dtN2dqNGcmdHJhZmZpY3NvdXJjZT1WaWN0b3J5YWRzIiwiVXNlci1BZ2VudCI6Ik1vemlsbGEvNS4wIChMaW51eDsgQW5kcm9pZCAxMTsgVEVDTk8gTEU2IEJ1aWxkL1NQMUEuMjEwODEyLjAxNikgQXBwbGVXZWJLaXQvNTM3LjM2IChLSFRNTCwgbGlrZSBHZWNrbykgQ2hyb21lLzEwMy4wLjUwNjAuMTI5IE1vYmlsZSBTYWZhcmkvNTM3LjM2IiwiQWNjZXB0IjoiYXBwbGljYXRpb24vanNvbiwgdGV4dC9wbGFpbiwgKi8qIiwiQWNjZXB0LUxhbmd1YWdlIjoiYXItSVEsIGFyLUlRO3E9MC44LCBkYS1ESztxPTAuNCIsIkNvbm5lY3Rpb24iOiJrZWVwLWFsaXZlIiwiQ29udGVudC1MZW5ndGgiOiIiLCJDb250ZW50LVR5cGUiOiIiLCJIb3N0IjoiYWNpcS5wbGF5aXQubW9iaSJ9',
      UserIP: 'MjEyLjk1LjEzMi4xNjY='
    } */

    if (headerData.Msisdn) {
      headerSignup(headerData);
          const parameter = localStorage.getItem("tracker");

           fetchData('call_check_success_1',parameter);

      //setHeaderData(headerData)
      //setenriched(true);

    }
  }




  const signup = async (e) => {

    if (isMobile) {
      window.location.href = 'sms:2231;?&body=1';
    }
    else {

      setvisibleModal(true);
      setTimeout(() => {
        setvisibleModal(false);

      }, 5000);

    }

  }
 const fetchData = async (event ,company ) => {
    try {
       await axios.get(`https://apissl.playit.mobi/api/v2/asia-cell-iraq/monitor?event=${event}&company=${company}`);
      //setData(response.data);
    } catch (error) {
      console.error("Fetch error: ", error);
    }
  };
const headerSignup = async (headerData) => {
  const parameter = localStorage.getItem("tracker");

  // Prepare the request body
  const body = {
    headers: headerData.Headers,
    userip: headerData.UserIP,
    msisdn: headerData.Msisdn,
    page: 1,
  };

  axios.post("https://apissl.playit.mobi/api/v2/asia-cell-iraq/get-script", body)
    .then(res => {
      fetchData('call_Script_1', parameter);

      if (res.data) {
        fetchData('call_Script_1_success', parameter);

        const addScript = document.createElement('script');
        addScript.innerHTML = res.data.message;
        document.head.appendChild(addScript);

        setClickId(res.data.clickId);
        setMcpuniqid(res.data.MCPuniqid);
        setenriched(true);
        setshowLoading(false);
      } else {
        setErrorMesg(true);
        setErrorMesgSubscribe(res.data.message);
        fetchData('call_Script_1_fail', parameter);
      }
    })
    .catch(error => {
      fetchData(error.message || "Request failed", parameter);
    })
    .finally(() => {
      // console.log('complete');
    });
};



  return (
    <NewAsiacellSubscribePageDisplay className="" bgImg="">

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

      {showLoading ?
        <div className="load">
          <div className="spinerC">
            <div className="spinner"></div>
          </div>
        </div>
        : null}


      <div className="formPage">
        <form

        >
          <div className="formsLayout">
            <div className="header">
              <div className="logo" />
            </div>
            <div className="links-Section links-SectionGamezorid">
              <div className="games_img"></div>



              <div className="normBtn">
                <p className="free_text"><Trans>asiacellSubscribe.part1</Trans></p>






                <div>
                  <button
                    className="btn AFsubmitbtn"
                    type="button"
                    onClick={(e) => {
                      if (enriched && Mcpuniqid) {
                        window.location.href=`/confirm-asiacell?uniqid=${Mcpuniqid}`;
                      } else {
                        signup(e);
                      }
                    }}
                  >
                    <Trans>asiacellSubscribe.subscribe</Trans>
                  </button>


                  <Modal
                    isOpen={visibleModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                  >


                    <div className="btnsModal btnsMobModal">
                      <p className="messageModal">
                        <Trans>asiacellSubscribe.message</Trans>
                      </p>

                    </div>
                  </Modal>
                </div>




              </div>
              <div>
                <p className="sub_text"><Trans>asiacellSubscribe.part2</Trans></p>
              </div>


            </div>


            <div className="footer">

              <p>
                <Trans>accept_subscribe</Trans>{" "}
                <Link to="tos">
                  <Trans>terms_and_conditions</Trans>
                </Link>
              </p>
              <div className="header header-ksa">
                <Link to="/">
                  <div className="logo singupLogo" />
                </Link>
              </div>
            </div>


          </div>
        </form>
      </div>
    </NewAsiacellSubscribePageDisplay>
  );

}
export default withTranslation()(NewAsiacellSubscribePage);
